import React from 'react';
import WebSocketProgress from './progressBar'

const LoadingSpinner = ({setLoading,toggleModal,selectedSource}) => {
  return (
    <div role="status">
        <WebSocketProgress setLoading={setLoading} toggleModal={toggleModal} selectedSource={selectedSource}/>
    </div>
  );
};

export default LoadingSpinner;